var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4167 8.00009H5.95833V5.3152C5.95833 4.28395 6.78385 3.42718 7.8151 3.41676C8.85677 3.40634 9.70833 4.2527 9.70833 5.29176V5.70843C9.70833 6.05478 9.98698 6.33343 10.3333 6.33343H11.1667C11.513 6.33343 11.7917 6.05478 11.7917 5.70843V5.29176C11.7917 3.10426 10.0078 1.32561 7.82031 1.3334C5.63281 1.34124 3.875 3.14332 3.875 5.33082V8.00009H3.25C2.5599 8.00009 2 8.55999 2 9.25009V13.4168C2 14.1069 2.5599 14.6668 3.25 14.6668H12.4167C13.1068 14.6668 13.6667 14.1069 13.6667 13.4168V9.25009C13.6667 8.55999 13.1068 8.00009 12.4167 8.00009Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock-open.1cc9a9ca4314dae2e9cf66f70c6d6f87.svg";
export { ForwardRef as ReactComponent };